// InfluencerCodes bei denen der Versand aktiviert wird
let shippingCodes 	= ["STEFANO"];
// "DE","BE","DK","DE","EE","FI","FR","GR","IS","IT","LV","LI","LT","LU","MT","NL","NO","AT","PL","PT","SE","CH","SK","SI","ES","CZ","HU"
let countries 		= {
  BE: ['Belgien',150,25],
  DK: ['Dänemark',150,25],
  DE: ['Deutschland',50,25],
  EE: ['Estland',150,25],
  FI: ['Finnland',150,25],
  FR: ['Frankreich',150,25],
  GR: ['Griechenland',150,25],
  IS: ['Island',150,25],
  IT: ['Italien',150,25],
  LV: ['Lettland',150,25],
  LI: ['Liechtenstein',150,25],
  LT: ['Litauen',150,25],
  LU: ['Luxemburg',150,25],
  MT: ['Malta',150,25],
  NL: ['Niederlande',150,25],
  NO: ['Norwegen',150,25],
  AT: ['Österreich',100,25],
  PL: ['Polen',150,25],
  PT: ['Portugal',150,25],
  SE: ['Schweden',150,25],
  CH: ['Schweiz',249,25],
  SK: ['Slowakei',150,25],
  SI: ['Slowenien',150,25],
  ES: ['Spanien',150,25],
  CZ: ['Tschechien',150,25],
  HU: ['Ungarn',150,25]
}
